import { Component, OnInit } from '@angular/core';
import { LoaderPageService } from '../service/loader-page.service';

@Component({
  selector: 'app-loader-page',
  templateUrl: './loader-page.component.html',
  styleUrls: ['./loader-page.component.scss'],
})
export class LoaderPageComponent {
  loading$ = this.loaderService.loading$;

  constructor(private loaderService: LoaderPageService) {}
}
